module.exports = __webpack_public_path__ + "static/media/rental.281eb179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/rental.jpg
// module id = 1132
// module chunks = 0